<section id="jc-footer-main">
  <footer>
    <!-- MOBILE VERSION OF ACCORDION FOOTER -->
    <div class="m-footer d-block d-lg-none">
      <div id="accordion1" (click)="toggleAccordion($event)">
        <div id="item1" class="card">
          <div class="card-header border-0">
            <a class="card-link accordion-title" data-toggle="collapse" href="#m-collapseOne" rel="noopener noreferrer">
              Products
            </a>
          </div>
          <div id="m-collapseOne" class="collapse show" data-parent="#accordion1">
            <div class="card-body">
              <ul>
                <li><a href="/" title="Click to navigate to JioAICloud" target="_blank" rel="noopener noreferrer">JioAICloud</a></li>
                <!-- <li class="">
                  <a href="/enterprise/about" rel="noopener noreferrer" title="Click to navigate to JioAICloud Enterprise">
                    <span title="Click to navigate to JioAICloud Enterprise">JioAICloud Enterprise</span>
                  </a>
                </li> -->
                <li><a href="{{this.jtrUrl}}" rel="noopener noreferrer" title="Click to navigate to JioTransfer" target="_blank">JioTransfer</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div id="item2" class="card">
          <div class="card-header">
            <a class="collapsed card-link accordion-title" data-toggle="collapse" href="#m-collapseTwo" rel="noopener noreferrer">
              Support
            </a>
          </div>
          <div id="m-collapseTwo" class="collapse" data-parent="#accordion1">
            <div class="card-body">
              <ul>
                <li><a href="/help/home" title="JioAICloud FAQs" target="_blank" rel="noopener noreferrer">FAQs</a></li>
                <!-- <li><a href="/how-to-videos/faq"  title="How to videos" target="_blank" rel="noopener noreferrer">How to Videos</a></li> -->
                <li><a href="mailto:care.jioaicloud@jio.com" target="_blank" title="Contact us" rel="noopener noreferrer">Contact us</a></li>
                @if (this.router.url != ('/about') && this.router.url != ('/contact-sales')) {
                  <li><a href="https://static.jiocloud.com/tos.html" tittle="Terms of Service" target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
                }
                @if (this.router.url != ('/about') && this.router.url != ('/contact-sales')) {
                  <li><a href="https://static.jiocloud.com/privacypolicy.html" tittle="Privacy Policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
                }
                @if (this.router.url == ('/about')) {
                  <li><a href="/enterprise/contact-sales" tittle="Contact sales" rel="noopener noreferrer">Contact Sales</a></li>
                }
              </ul>
            </div>
          </div>
        </div>
        <div id="item3" class="card">
          <div class="card-header">
            <a class="collapsed card-link accordion-title" data-toggle="collapse" href="#m-collapseThree" rel="noopener noreferrer">
              Our companies
            </a>
          </div>
          <div id="m-collapseThree" class="collapse" data-parent="#accordion1">
            <div class="card-body">

              <ul>
                <li><a href="https://www.ril.com" target="_blank" title="Click to experience Reliance Industries" rel="noopener noreferrer">Reliance Industries</a></li>
                <li><a href="https://www.reliancefoundation.org" target="_blank" title="Click to experience Reliance Foundation" rel="noopener noreferrer">Reliance Foundation</a></li>
                <li><a href="https://www.jio.com/" target="_blank" title="Click to experience Jio" rel="noopener noreferrer">Jio</a></li>
              </ul>

            </div>
          </div>
        </div>

      </div>
    </div>


    <div class="row m-0 p-0 footer-inner">
      <!-- Hiding for mobile ----->
      <div class="col-lg-3 p-0 d-none d-lg-block">
        <div class="footer-links">
          <h2>Products</h2>
          <ul>
            <li><a href="/" title="Click to navigate to JioAICloud" target="_blank" rel="noopener noreferrer">JioAICloud</a></li>
            <!-- <li><a href="/enterprise/about" title="Click to navigate to JioAICloud Enterprise" rel="noopener noreferrer">JioCloud Enterprise</a></li> -->
            <li><a href="{{jtrUrl}}"  title="Click to navigate to JioTransfer" target="_blank" rel="noopener noreferrer">JioTransfer</a></li>
          </ul>
        </div>
      </div>
      <div class="col-lg-3 p-0 d-none d-lg-block">
        <div class="footer-links">
          <h2>Support</h2>
          <ul>
            <li><a href="/help/home" title="JioAICloud FAQs" target="_blank" rel="noopener noreferrer">FAQs</a></li>
            <!-- <li><a href="/how-to-videos/faq" title="How to Videos" target="_blank" rel="noopener noreferrer">How to Videos</a></li> -->
            <li><a href="mailto:care.jioaicloud@jio.com" target="_blank" title="Contact us" rel="noopener noreferrer">Contact us</a></li>
            @if (this.router.url != ('/about') && this.router.url != ('/contact-sales')) {
              <li><a href="https://static.jiocloud.com/tos.html" tittle="Terms of Service" target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
            }
            @if (this.router.url != ('/about') && this.router.url != ('/contact-sales')) {
              <li><a href="https://static.jiocloud.com/privacypolicy.html" tittle="Privacy Policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
            }
            @if (this.router.url == ('/about')) {
              <li><a href="/enterprise/contact-sales" tittle="Contact sales" rel="noopener noreferrer">Contact Sales</a></li>
            }
          </ul>
        </div>
      </div>
      <div class="col-lg-3 p-0 d-none d-lg-block">
        <div class="footer-links">
          <h2>Our companies</h2>
          <ul>
            <li><a href="https://www.ril.com" target="_blank" title="Click to experience Reliance industries" rel="noopener noreferrer">Reliance Industries</a></li>
            <li><a href="https://www.reliancefoundation.org" target="_blank" title="Click to experience Reliance foundation" rel="noopener noreferrer">Reliance Foundation</a></li>
            <li><a href="https://www.jio.com/" target="_blank" title="Click to experience Jio" rel="noopener noreferrer" rel="noopener noreferrer">Jio</a></li>
          </ul>
        </div>
      </div>
      <div class="col-lg-3 col-12 p-0">
        <div class="connect-with-us mt-5 mt-lg-0">
          <h2>Connect with us</h2>
          <ul>
            <li>
              <a href="https://twitter.com/reliancejio" class="f-link" title="Click to connect on Twitter" target="_blank" rel="noopener noreferrer">
                <img src="https://static.jiocloud.com/web2.0/landing/Images/icons8-twitter.svg" class="img-fluid" alt="Jio Twitter" height="100%" width="100%"/>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/reliancejio/" class="f-link" title="Click to connect on Instagram" target="_blank" rel="noopener noreferrer">
                <img src="https://static.jiocloud.com/web2.0/landing/Images/icons8-instagram.svg" class="img-fluid" alt="Jio Instagram" height="100%" width="100%"/>
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/Jio" class="f-link" title="Click to connect on Facebook" target="_blank" rel="noopener noreferrer">
                <img src="https://static.jiocloud.com/web2.0/landing/Images/icons8-facebook.svg" class="img-fluid" alt="Jio Facebook" height="100%" width="100%"/>
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCG1SQcGXfpde6SWtmdhE2Rg" class="f-link" title="Click to connect on Youtube" target="_blank" rel="noopener noreferrer">
                <img src="https://static.jiocloud.com/web2.0/landing/Images/icons8-youtube.svg" class="img-fluid" alt="Jio Youtube" height="100%" width="100%"/>
              </a>
            </li>
            <li>
              <a href="https://in.linkedin.com/company/jioplatforms" class="f-link" title="Click to connect on Linkedin" target="_blank" rel="noopener noreferrer">
                <img src="https://static.jiocloud.com/web2.0/landing/Images/icons8-linkedin.svg" class="img-fluid" alt="Jio Linkedin" height="100%" width="100%"/>
              </a>
            </li>
          </ul>
        </div>
        <div class="download-jiocloud mt-5">
          <h2>Download JioAICloud</h2>
          <ul>
            <li>
              <a href="{{androidDownloadURL}}" class="f-link" title="Click to download for Android" target="_blank" rel="noopener noreferrer">
                <span class="Neueandroid-logo"></span>
              </a>
            </li>
            <li>
              <a href="{{iosDownloadURL}}" class="f-link" title="Click to download for IOS" target="_blank" rel="noopener noreferrer">
                <span class="NeueApple"></span>
              </a>
            </li>
            <li>
              <a href="{{macDownloadURL}}" class="f-link" title="Click to download for Mac" target="_blank" rel="noopener noreferrer">
                <span class="NeueMAC"></span>
              </a>
            </li>
            <li>
              <a href="{{windowsDownloadURL}}" class="f-link" title="Click to download for Windows" target="_blank" rel="noopener noreferrer">
                <span class="NeueWindows"></span>
              </a>
            </li>
            <li>
              <span class="f-link" title="Click to connect on Feature phone" >
                <span class="NeueFeature-phone"></span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</section>